<template>
  <div id="home" ref="home">
    <transition name="fadeInOut">
      <div class="inputArea" v-show="showM" @click="()=>{if(!this.ifBonus){this.showM=false}}">
        <div v-show="ifBonus">
          <div class="top-tips">
            <img src="https://jd-asset.elloworld.cn/desirecity/img/tip8.png" alt="">
          </div>
          <div class="tips2">
            <img src="https://jd-asset.elloworld.cn/desirecity/img/tip2.png" alt="">
          </div>
          <div class="tips3">
            <img src="https://jd-asset.elloworld.cn/desirecity/img/tip3.png" alt="">
          </div>
          <div class="message-bg">
            <img src="https://jd-asset.elloworld.cn/desirecity/img/message_bg.png" alt="">
            <input type="text" maxlength="9" class="name"
                   @blur="checkName">
            <input type="text" maxlength="11" class="phone" @blur="checkPhone">
            <textarea class="address" @blur="checkAddress"/>
            <div class="wrong1" v-show="nameWrong"><img src="https://jd-asset.elloworld.cn/desirecity/img/tip.png"
                                                        alt=""> 请输入您的名字
            </div>
            <div class="wrong2" v-show="phoneWrong"><img src="https://jd-asset.elloworld.cn/desirecity/img/tip.png"
                                                         alt=""> 请输入正确的手机号
            </div>
            <div class="wrong3" v-show="addressWrong"><img src="https://jd-asset.elloworld.cn/desirecity/img/tip.png"
                                                           alt=""> 请输入您的地址
            </div>
          </div>
          <div class="btn" @click="submitMes">
            <img src="https://jd-asset.elloworld.cn/desirecity/img/button3.png" alt="">
          </div>
          <div class="close" @click="()=>{this.showM=false}">
            <img src="https://jd-asset.elloworld.cn/desirecity/img/close.png" alt="">
          </div>
        </div>
        <div v-show="!ifBonus" class="share">
          <div class="s-mask">
            <img src="https://jd-asset.elloworld.cn/desirecity/img/s_mask.png" alt="">
          </div>
          <div class="animte">
            <div class="s-light">
              <img src="https://jd-asset.elloworld.cn/desirecity/img/s_light.png" alt="">
            </div>
            <div class="s-tips">
              <img src="https://jd-asset.elloworld.cn/desirecity/img/s_tips.png" alt="">
            </div>
            <div class="s-star">
              <img src="https://jd-asset.elloworld.cn/desirecity/img/s_star.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fadeInOut">
      <div class="result" v-show="resultShow">
        <div class="success" v-show="ifSuccess">
          <img src="https://jd-asset.elloworld.cn/desirecity/img/success.png" alt="">
        </div>
        <div class="failure" v-show="!ifSuccess">
          <img src="https://jd-asset.elloworld.cn/desirecity/img/failure.png" alt="">
        </div>
        <div class="close" ref="close" @click="closeResult">
          <img src="https://jd-asset.elloworld.cn/desirecity/img/close.png" alt="">
        </div>
      </div>
    </transition>
    <transition name="fadeInOut">
      <div class="box" v-show="pro_show" :style="{marginTop:transY}">
        <div class="progress">
          <div class="loaded" :style="{width:200/100*l_pro+'px'}">
          </div>
        </div>
        <div class="after" :style="{left:246+240/100*l_pro+'px'}">
          <img src="https://jd-asset.elloworld.cn/desirecity/img/star.png" alt="">
        </div>
      </div>
    </transition>
    <div class="poster" v-show="posterImgShow">
      <!--<div class="title">-->
      <!--<img src="images/tips/save.png" alt="">-->
      <!--</div>-->
      <div class="poster-img">
        <img :src="posterImg" alt="">
      </div>
      <!--<div class="close" @click="()=>{this.posterImgShow=false;this.playSound('click')}">-->
      <!--<img src="images/tips/close.png" alt="">-->
      <!--</div>-->
    </div>
    <div class="video-box" v-show="videoShow" ref="video_box">
      <video src="https://jd-asset.elloworld.cn/desirecity/open.mp4"
             poster="https://jd-asset.elloworld.cn/desirecity/poster.png"
             x-webkit-airplay="true"
             playsinline="true"
             webkit-playsinline="true"
             x5-video-player-type="h5"
             x5-video-player-fullscreen="true"
             :class="showVideo?'videoplaying':'video'" ref="video"
             :style="{'margin-top':transY+'px'}"
      >
      </video>
    </div>
    <div class="video-wrapper" v-show="cityVideoShow">
      <video src="https://jd-asset.elloworld.cn/desirecity/shanghai.mp4"
             x-webkit-airplay="true"
             playsinline="true"
             webkit-playsinline="true"
             x5-video-player-type="h5"
             x5-video-player-fullscreen="true"
             class="city-video"
             ref="city_video"
      >
      </video>
      <div class="close" @click="pauseVideo">
        <img src="https://jd-asset.elloworld.cn/desirecity/img/close.png" alt="">
      </div>
    </div>

    <audio id="audio" src="https://jd-asset.elloworld.cn/desirecity/music/bgm.mp3" autoplay="autoplay" loop
           ref="audio"></audio>
    <audio class="bonus" src="https://jd-asset.elloworld.cn/desirecity/music/bonus.mp3" ref="bonus"></audio>
    <audio class="bubble" src="https://jd-asset.elloworld.cn/desirecity/music/bubble.mp3" ref="bubble"></audio>
    <audio class="click" src="https://jd-asset.elloworld.cn/desirecity/music/click.mp3" ref="click"></audio>
    <audio class="getlight" src="https://jd-asset.elloworld.cn/desirecity/music/getlight.mp3" ref="getlight"></audio>
    <audio class="light" src="https://jd-asset.elloworld.cn/desirecity/music/light.mp3" ref="light"></audio>
    <audio class="nobonus" src="https://jd-asset.elloworld.cn/desirecity/music/nobonus.mp3" ref="nobonus"></audio>
    <audio class="share" src="https://jd-asset.elloworld.cn/desirecity/music/share.mp3" ref="share"></audio>
    <audio class="togglecity" src="https://jd-asset.elloworld.cn/desirecity/music/togglecity.mp3"
           ref="togglecity"></audio>

  </div>
</template>

<script>
  import * as PIXI from "pixi.js";
  import {imgPos, imgData, jsonData} from '../assets/js/data'
  import axios from 'axios'
  import md5 from 'md5'
  import Env from '../assets/js/screen'
  import AlloyFinger from 'alloyfinger'

  export default {
    name: "HelloWorld",
    props: ['share_success'],
    data() {
      return {
        width: 0,
        height: 0,
        app: null,
        stageContainer: null,
        loadingContainer: null,
        lotteryContainer: null,
        tipsContainer: null,
        getLightContainer: null,
        shopLogoContainer: null,
        shareContainer: null,
        loaderResources: [],
        l_pro: 0,
        pro_show: true,
        loaderImg: null,
        mySprites: {},
        lotterySprite: {},
        loadingSprite: {},
        getLightNum: 0,
        lightStage: {
          l1: false,
          l2: false,
          l3: false,
          l4: false,
          l5: false,
          l6: false,
        },
        loader: null,
        objScroller: null,
        tl: {},
        curTimeline: null,
        tlplay: true,
        loadprogress: 0,
        showM: false,
        ifBonus: null,
        showVideo: false,
        canAni: false,
        curProduct: '',
        playing: true,
        curPage: 1,
        curShop: '',
        curProName: '',
        curProShop: '',
        phoneWrong: false,
        nameWrong: false,
        addressWrong: false,
        message: {
          name: '',
          phone: '',
          address: ''
        },
        transY: 0,
        posterImg: '',
        posterImgShow: false,
        resultShow: false,
        ifSuccess: true,
        cityVideoShow: false,
        bonusType: 1,
        isFirst: true,
        firstShare: 1,
        af: null,
        videoShow: false,
        isFirstPlay: true,
        testUrl: 'https://admin.elloworld.cn/jdapi/index.php/home/checkAuth',
        mainUrl: 'https://idea.elloworld.cn/jdapi/index.php/home/checkAuth'
      };
    },
    created() {
      // let _this = this

      this.loader = new PIXI.Loader()
      this.stageContainer = new PIXI.Container();
      this.loadingContainer = new PIXI.Container()
      this.tipsContainer = new PIXI.Container()
      this.getLightContainer = new PIXI.Container()
      this.shopLogoContainer = new PIXI.Container()

      this.tipsContainer.visible = false
      this.getLightContainer.visible = false
      this.loadingContainer.visible = true
      this.stageContainer.visible = false
      this.shopLogoContainer.visible = false

      this.getLightContainer.alpha = 0
      this.tipsContainer.alpha = 0
      this.shopLogoContainer.alpha = 0

      this.loaderImg = new PIXI.Loader()
      this.loaderImg.add([
        './images/loading/loading.png',
        './images/loading/loading.json',
        './images/loading/light_ani.png',
        './images/loading/light_ani.json',
        './images/bg/load_bg.jpg'
      ])

      this.loaderImg.load()
      this.loaderImg.onComplete.add(() => {
        this.initApp()
        let mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRect(0, 1400, this.width, this.height);
        mask.endFill();
        this.loadingContainer.addChild(mask)

        let loadId = this.loaderImg.resources['./images/loading/loading.json'].textures
        let bg = PIXI.Sprite.from('./images/bg/load_bg.jpg')
        this.loadingContainer.addChild(bg)


        let l_618 = PIXI.Sprite.from(loadId['618.png'])
        l_618.anchor.set(.5, 0)
        l_618.x = this.width / 2 + 4
        l_618.y = -150
        this.loadingContainer.addChild(l_618)


        let l_title = PIXI.Sprite.from(loadId['title.png'])
        l_title.y = -967
        this.loadingSprite['l_title'] = l_title
        this.loadingContainer.addChild(l_title)

        let l_mask = PIXI.Sprite.from(loadId['shadow.png'])
        l_mask.anchor.set(0.5)
        l_mask.x = 418
        l_mask.y = 995.5
        this.loadingContainer.addChild(l_mask)
        let ani = TweenMax.to(l_mask.scale, 1.5, {
          x: 0.8,
          y: 0.8,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })

        let layer = PIXI.Sprite.from(loadId['l_layer.png'])
        layer.anchor.set(0.5)
        layer.x = 595
        layer.y = 878
        layer.alpha = 0
        this.loadingSprite['layer'] = layer
        this.loadingContainer.addChild(layer)


        let l_light = this.createFrameAni('light_an', 36, .4)
        l_light.anchor.set(0.5)
        l_light.x = 375
        l_light.y = 728
        l_light.play()
        l_light.interactive = true
        this.loadingSprite['l_light'] = l_light
        this.loadingContainer.addChild(l_light)


        // let lighter = new PIXI.Sprite()
        // lighter.anchor.set(1, 0)
        // lighter.x = 500
        // lighter.y = 761
        // this.loadingContainer.addChild(lighter)


        let music = PIXI.Sprite.from(loadId['music_on.png'])
        music.y = -360
        music.x = 14
        this.loadingSprite['music'] = music
        music.zIndex = 10
        this.app.stage.addChild(music)

        let music_off = PIXI.Sprite.from(loadId['music_off.png'])
        music_off.x = 31
        music_off.y = 216
        music_off.alpha = 0
        music_off.interactive = true
        music.addChild(music_off)
        music_off.on('pointertap', () => {
          music_off.alpha = !music_off.alpha
          if (music_off.alpha) {
            this.$refs.audio.pause()
          } else {
            this.$refs.audio.play()
          }
        })

        let loadingBox = PIXI.Sprite.from(loadId['loading_box.png'])
        loadingBox.anchor.set(0.5, 0)
        loadingBox.x = this.width / 2
        this.loadingContainer.addChild(loadingBox)

        let num1 = PIXI.Sprite.from(loadId['n0.png'])
        num1.anchor.set(0.5, 0)
        num1.y = 495
        num1.x = 7
        loadingBox.addChild(num1)

        let num2 = PIXI.Sprite.from(loadId['n0.png'])
        num2.anchor.set(0.5, 0)
        num2.y = 495
        num2.x = -18
        loadingBox.addChild(num2)

        let num3 = PIXI.Sprite.from(loadId['n1.png'])
        num3.anchor.set(0.5, 0)
        num3.y = 495
        num3.x = -39
        num3.visible = false
        loadingBox.addChild(num3)

        let percent = PIXI.Sprite.from(loadId['precent.png'])
        percent.anchor.set(0.5, 0)
        percent.y = 505
        percent.x = 35
        loadingBox.addChild(percent)


        // lighter.on('pointertap', () => {
        //   this.$refs.video.play()
        // })


        for (let i = 0; i < imgData.length; i++) {
          this.loader.add(imgData[i])
        }

        this.loader.load()

        this.loader.onComplete.add((loader, resources) => {
          let light_ani = this.createFrameAni('tip_finger', 20, .3)
          light_ani.play()
          light_ani.x = 460
          light_ani.y = 751
          this.loadingContainer.addChild(light_ani)
          light_ani.alpha = 0
          this.loadingSprite['lighter'] = light_ani
          TweenMax.to(light_ani, 1, {alpha: 1})
          TweenMax.to(layer, 1, {alpha: 1})
          this.createStagePage()
          this.createLotteryPage()
          this.createTips()
          this.createGetLight()
          this.createShare()
          this.createShopMask()
          this.initScroll()
          this.initCitySnap()
        })
        this.loader.onProgress.add(() => {
          let a = parseInt(this.loader.progress % 10 + '')
          let b = parseInt((this.loader.progress % 100) / 10 + '')
          num1.texture = loadId['n' + a + '.png']
          num2.texture = loadId['n' + b + '.png']
          this.l_pro = Math.ceil(this.loader.progress)
          // console.log(this.l_pro)
          if (Math.ceil(this.loader.progress) === 100) {
            this.pro_show = false
            num3.visible = true
            this.videoShow = true


            num1.texture = loadId['n0.png']
            num2.texture = loadId['n0.png']
            TweenMax.to(l_618, 1, {y: 0})
            TweenMax.to(music, 1, {y: -100})
            TweenMax.to(loadingBox, 1, {alpha: 0})
            TweenMax.to(l_title, .5, {
              y: -368,
              onComplete: () => {
                let a = this.loopAnimation(l_title, 1.5, -10)
                this.loadingSprite['l_title_ani'] = a
              }
            })
          }
        })

      })

      // function animate(time) {
      //   requestAnimationFrame(animate);
      //   TWEEN.update(time);
      // }
      //
      // requestAnimationFrame(animate);
    },
    mounted() {
      let el = this.$refs.video
      var env = Env()
      this.af = new AlloyFinger(el, {
        touchStart: function () {
        },
        tap: function () {
        }
      });
      if (env.isAndroid) {
        this.af.on('tap', this.playVideo)
      } else {
        this.af.on('touchStart', this.playVideo)
      }
    },
    methods: {
      initApp() {
        this.width = document.body.clientWidth;
        this.height = document.body.clientHeight;
        if (this.height <= 1468 - 80) {
          this.transY = this.height - 1468 + 80
        } else {
          this.transY = 0
        }
        console.log(this.width, this.height);
        this.app = new PIXI.Application({
          width: 750,
          height: this.height,
          backgroundColor: "0xffffff"
        });
        this.app.renderer.autoResize = true;
        this.$el.appendChild(this.app.view);
        this.app.stage.addChild(this.stageContainer);

        this.stageContainer.interactive = true;
        this.getLightContainer.interactive = true
        this.tipsContainer.interactive = true
        this.loadingContainer.interactive = true
        this.shopLogoContainer.interactive = true

        this.app.stage.sortableChildren = true
        this.stageContainer.sortableChildren = true;

        this.tipsContainer.zIndex = 10
        this.loadingContainer.zIndex = 15
        this.getLightContainer.zIndex = 25
        this.shopLogoContainer.zIndex = 25
        this.app.stage.addChild(this.tipsContainer);
        this.app.stage.addChild(this.getLightContainer);
        this.app.stage.addChild(this.loadingContainer);
        this.app.stage.addChild(this.shopLogoContainer);
        this.loadingContainer.y = this.transY
      },
      initScroll() {
        let _this = this
        this.objScroller = new Scroller(this.scrollerCallback, {
          scrollX: false,
          animating: true,
          bouncing: false,
          animationDuration: 250
        });
        var scrollY = 11439; //视具体视觉效果而定
        this.objScroller.setDimensions(
          this.app.screen.width,
          this.app.screen.height,
          this.app.screen.width,
          scrollY
        );
        this.objScroller.scrollTo(0, -this.transY, false)
        this.stageContainer
          .on("pointerdown", onTouchStart)
          .on("pointermove", onTouchMove)
          .on("pointerup", onTouchEnd);

        let isTouching;

        function onTouchStart(e) {
          var i = e.data.originalEvent;
          isTouching = true;
          _this.objScroller.doTouchStart(i.touches, i.timeStamp);
        }

        function onTouchMove(e) {
          if (isTouching) {
            var i = e.data.originalEvent;
            _this.objScroller.doTouchMove(i.touches, i.timeStamp, i.scale);
          }
        }

        function onTouchEnd(e) {
          var i = e.data.originalEvent;
          _this.objScroller.doTouchEnd(i.timeStamp);
          isTouching = false;
          // _this.tl.resume()
          // _this.stopTimeLine(true)
        }
      },
      createStagePage() {
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures
        let loadId = this.loaderImg.resources['./images/loading/loading.json'].textures
        let logoId = this.loader.resources['./images/tips/logo.json'].textures
        let proId = this.loader.resources['./images/production/production.json'].textures


        for (let i = 0; i < 9; i++) {
          let a = PIXI.Sprite.from('./images/bg/bg_0' + (i + 1) + '.jpg')
          a.x = 0
          a.y = 1334 * i
          this.stageContainer.addChild(a)
        }


        let yun_t1 = this.createYunAni('yun_t', 20)
        yun_t1.anchor.set(.5, 0)
        yun_t1.x = 0
        yun_t1.y = 2600
        yun_t1.play()
        this.stageContainer.addChild(yun_t1)


        let yun_t2 = this.createYunAni('yun_t', 20)
        yun_t2.anchor.set(.5, 0)
        yun_t2.x = 550
        yun_t2.y = 2400
        yun_t2.scale.set(1.2)
        yun_t2.play()
        this.stageContainer.addChild(yun_t2)


        let yun_t3 = this.createYunAni('yun_t', 20)
        yun_t3.anchor.set(.5, 0)
        yun_t3.x = 0
        yun_t3.y = 4800
        yun_t3.scale.set(1.5)
        yun_t3.play()
        this.stageContainer.addChild(yun_t3)
        let yun_t4 = this.createYunAni('yun_t', 20)
        yun_t4.anchor.set(.5, 0)
        yun_t4.x = 650
        yun_t4.y = 4800
        yun_t4.play()
        this.stageContainer.addChild(yun_t4)

        let yun_t5 = this.createYunAni('yun_t', 20)
        yun_t5.anchor.set(.5, 0)
        yun_t5.x = 100
        yun_t5.y = 6900
        yun_t5.scale.set(1.5)
        yun_t5.play()

        this.stageContainer.addChild(yun_t5)

        let yun_t6 = this.createYunAni('yun_t', 20)
        yun_t6.anchor.set(.5, 0)
        yun_t6.x = 750
        yun_t6.y = 7200
        yun_t6.play()

        this.stageContainer.addChild(yun_t6)


        let yun_t7 = this.createYunAni('yun_t', 20)
        yun_t7.anchor.set(.5, 0)
        yun_t7.x = 200
        yun_t7.y = 9500
        yun_t7.play()
        // yun_t7.scale.set(1)
        this.stageContainer.addChild(yun_t7)

        let yun_t8 = this.createYunAni('yun_t', 20)
        yun_t8.anchor.set(.5, 0)
        yun_t8.x = 750
        yun_t8.y = 9400
        yun_t8.play()
        this.stageContainer.addChild(yun_t8)

        // let yun_t9 = this.createYunAni('yun_t', 20)
        // yun_t9.anchor.set(.5, 0)
        // yun_t9.x = 375
        // yun_t9.y = 11300
        // yun_t9.scale.set(2)
        // this.stageContainer.addChild(yun_t9)

        this.loopAnimation(yun_t1, 1.5, 10)
        this.loopAnimation(yun_t2, 1.5, 10, 0.5)
        this.loopAnimation(yun_t3, 1.5, 10)
        this.loopAnimation(yun_t4, 1.5, 10, 0.5)
        this.loopAnimation(yun_t5, 1.5, 10)
        this.loopAnimation(yun_t6, 1.5, 10, 0.5)
        this.loopAnimation(yun_t7, 1.5, 10)
        this.loopAnimation(yun_t8, 1.5, 10, 0.5)


        let b = PIXI.Sprite.from(loadId['title.png'])
        b.y = -300
        this.stageContainer.addChild(b)
        this.loadingSprite['s_title'] = b
        let fire1 = this.createFrameAni('t_fire', 18, .3)
        fire1.play()
        fire1.x = -80
        fire1.y = 800
        b.addChild(fire1)

        let feitanTextures = [];
        let k;

        for (k = 0; k < 19; k++) {
          let texture = PIXI.Texture.from('feitan_' + k + '.png');
          feitanTextures.push(texture);
        }
        var feitan = new PIXI.AnimatedSprite(feitanTextures);
        feitan.anchor.set(.5)
        feitan.y = 659
        feitan.x = 388
        feitan.animationSpeed = .3
        feitan.gotoAndStop(1)
        feitan.scale.set(1.055)
        this.loadingSprite['feitan'] = feitan
        this.stageContainer.addChild(feitan)

        let move = false
        let startY = 0


        let littl1 = this.createlittleLight(0, this.width / 2, 590)
        this.stageContainer.addChild(littl1)

        var Arr = [];// 声明一个变量并赋值
        var add = 0;
        while (add < 4) {
          var num = Math.floor(15 * Math.random());
          if (Arr.indexOf(num) === -1) {
            Arr.push(num);
            add++;
          }
          Arr.sort(function (a, b) {
            return b - a
          })
        }
        let bnh = this.createTitleAni('bnh', 21)
        bnh.x = 0
        bnh.y = 951
        this.loadingSprite['bnh'] = bnh
        this.stageContainer.addChild(bnh)
        let fire2 = this.createFrameAni('g_fire', 24, .3)
        fire2.x = 0
        fire2.y = 150
        fire2.play()
        bnh.addChild(fire2)

        let yycb = this.createTitleAni('yycb', 15)
        yycb.x = 0
        yycb.y = 3003
        yycb.play()
        this.stageContainer.addChild(yycb)
        let fire3 = this.createFrameAni('g_fire', 24, .3)
        fire3.x = 0
        fire3.y = 150
        fire3.play()
        yycb.addChild(fire3)

        let sjbwg = this.createTitleAni('sjbwg', 15)
        sjbwg.x = 353
        sjbwg.y = 5120
        sjbwg.play()
        this.stageContainer.addChild(sjbwg)
        let fire4 = this.createFrameAni('g_fire', 24, .3)
        fire4.x = 0
        fire4.y = 150
        fire4.play()
        sjbwg.addChild(fire4)

        let diygf = this.createTitleAni('diy', 15)
        diygf.x = 170
        diygf.y = 7584
        diygf.play()
        this.stageContainer.addChild(diygf)
        let fire5 = this.createFrameAni('g_fire', 24, .3)
        fire5.x = 0
        fire5.y = 250
        fire5.play()
        diygf.addChild(fire5)

        let xyw = this.createTitleAni('xyw', 15)
        xyw.x = 173
        xyw.y = 9877
        xyw.play()
        xyw.zIndex = 1
        this.stageContainer.addChild(xyw)
        let fire6 = this.createFrameAni('g_fire', 24, .3)
        fire6.x = 0
        fire6.y = 150
        fire6.play()
        xyw.addChild(fire6)

        let com = new Set()
        for (let m = 0; m < imgPos.length; m++) {
          let element = imgPos[m]
          if (element.com) {
            com.add(element.com)
          }
        }
        let coms = Array.from(com)
        console.log(coms)
        console.log(Arr)

        let shareImgTexture = {}

        for (let i = 0; i < coms.length; i++) {
          shareImgTexture[coms[i]] = PIXI.Texture.from('./images/share_img/' + coms[i] + '.png')
        }

        for (let j = 0; j < imgPos.length; j++) {
          let element = imgPos[j]
          let texturePro = this.loader.resources[element.json].textures
          let box = new PIXI.Container()
          this.stageContainer.addChild(box)
          let b = PIXI.Sprite.from(texturePro[element.name + '.png'])
          box.addChild(b)
          box.x = element.start.x
          box.y = element.start.y
          if (element.com) {
            box.interactive = true
            if (element.name === 'thinkpad2') {
              box.hitArea = new PIXI.Rectangle(0, 0, 334, 200)
            }
            box.on('pointerdown', (e) => {
              this.playSound('click')
              startY = this.stageContainer.y
            })

            // let texture = PIXI.Texture.from('./images/share_img/' + element.com + '.png')
            box.on('pointerup', (e) => {
              move = Math.abs(this.stageContainer.y - startY) > 0
              if (!move) {
                this.curProduct = element.proUrl
                // let el = this.loadingSprite.littleBox.children
                this.playSound('share')
                // this.showPageAnimate(this.shareContainer)
                // this.showPageAnimate(this.loadingSprite.share_mask)
                this.shareContainer.visible = true

                // this.showPageAnimate(this.loadingSprite.share_img)
                // this.loadingSprite.share_img.texture = PIXI.Texture.from('./images/share_img/' + element.com + '.png')
                this.loadingSprite.share_img.texture = shareImgTexture[element.com]
                // this.createshareImg(element.com)
                // console.log(this.loadingSprite.share_img.texture)
                // console.log(shareImgTexture[element.com])
                this.posterImg = 'https://jd-asset.elloworld.cn/desirecity/images/' + element.com + '.png'
                this.posterImgShow = true
                this.curProName = element.name
                for (let i = 0; i < this.loadingSprite.littleBox.children.length; i++) {
                  this.loadingSprite.littleBox.children[i].visible = false
                }
                if (element.com === coms[Arr[0]] && !this.lightStage.l2) {
                  this.loadingSprite.littleBox.children[0].visible = true
                }
                if (element.com === coms[Arr[1]] && !this.lightStage.l3) {
                  this.loadingSprite.littleBox.children[1].visible = true
                }
                if (element.com === coms[Arr[2]] && !this.lightStage.l4) {
                  this.loadingSprite.littleBox.children[2].visible = true
                }
                if (element.com === coms[Arr[3]] && !this.lightStage.l5) {
                  this.loadingSprite.littleBox.children[3].visible = true
                }

              }
            })
          }
          if (element.type === 'dynamic') {
            let tl = this.loopAnimation(b, 1, 10, j / 5)
            this.tl[element.name] = tl
          }
          if (element.islogo) {
            let add = PIXI.Sprite.from(tipsId['add.png'])
            add.x = element.addPos.x
            add.y = element.addPos.y
            add.interactive = true
            box.addChild(add)
            TweenMax.to(add, 1, {alpha: 0, repeat: -1, yoyo: true, delay: Math.random()})
            add.on('pointerdown', () => {
              this.playSound('getlight')
              startY = this.stageContainer.y
            })
            add.on('pointerup', () => {
              move = Math.abs(this.stageContainer.y - startY) > 0
              if (!move) {
                this.curProShop = element.shopname
                this.curShop = element.shopUrl
                this.loadingSprite.m_title.texture = logoId[element.shopname + '.png']
                this.loadingSprite.m_btn.texture = proId[element.direction + '.png']
                this.shopLogoContainer.interactive = true
                this.showPageAnimate(this.shopLogoContainer)
                TweenMax.to(this.loadingSprite.m_title, .5, {y: 0})
                TweenMax.to(this.loadingSprite.m_btn, .5, {y: 0})
              }
            })
          }
          this.mySprites[element.name] = {
            tar: box,
            startY: element.start.y
          }
        }


        let handtip1 = this.createProTip(0)
        handtip1.position.set(273, 2705)
        this.stageContainer.addChild(handtip1)

        let handtip2 = this.createProTip(0)
        handtip2.position.set(273, 2155)
        this.stageContainer.addChild(handtip2)
        let handtip3 = this.createProTip(0)
        handtip3.position.set(273, 3905)
        this.stageContainer.addChild(handtip3)

        let handtip4 = this.createProTip(1)
        handtip4.position.set(273, 5505)
        this.stageContainer.addChild(handtip4)

        let handtip5 = this.createProTip(1)
        handtip5.position.set(303, 8505)
        this.stageContainer.addChild(handtip5)
        let handtip6 = this.createProTip(0)
        handtip6.position.set(453, 1555)
        this.stageContainer.addChild(handtip6)
      },
      createLotteryPage() {
        this.lotteryContainer = new PIXI.Container()
        this.lotteryContainer.visible = false
        this.lotteryContainer.alpha = 0
        this.lotteryContainer.interactive = true
        this.lotteryContainer.zIndex = 20
        this.app.stage.addChild(this.lotteryContainer);

        let bg = PIXI.Sprite.from('./images/bg/lottery_bg.png')
        this.lotteryContainer.addChild(bg)
        this.lotteryContainer.visible = false
        let lotteryId = this.loader.resources['./images/lottery/lottery.json'].textures
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures
        let yunId = this.loader.resources['./images/yun/yun.json'].textures

        for (let i = 0; i < 5; i++) {
          var yun = PIXI.Sprite.from(yunId['yun0' + (i + 1) + '.png'])
          yun.anchor.set(0, 1)
          yun.x = 0
          yun.y = this.height
          if (i === 0) {
            yun.x = 178
          }
          if (i === 2) {
            yun.anchor.set(.5)
            yun.x = 375
            yun.y = this.height / 2 + 316
          } else {
            this.loopAnimation(yun, 1.5 + i * 0.1, 20)
          }
          this.lotteryContainer.addChild(yun)
        }
        //标题
        let box = new PIXI.Sprite()
        let title = PIXI.Sprite.from(lotteryId['l_title.png'])
        box.y = this.height / 2 - 750 - 500
        box.addChild(title)
        this.loadingSprite['lottery_title'] = box
        this.loopAnimation(title, 2, 20)
        this.lotteryContainer.addChild(box)

        //神灯
        let ligth = PIXI.Sprite.from(tipsId['light2.png'])
        ligth.anchor.set(0, .5)
        ligth.x = 101
        ligth.y = this.height / 2
        ligth.interactive = true
        this.loadingSprite['lottery_light'] = ligth
        this.lotteryContainer.addChild(ligth)
        //光效
        let effect1 = PIXI.Sprite.from(lotteryId['eff1.png'])
        effect1.x = 8.5
        this.lotterySprite['eff1'] = effect1
        this.lotteryContainer.addChild(effect1)
        //没有中奖提示
        let noBonus = PIXI.Sprite.from(lotteryId['tip5.png'])
        noBonus.x = 148
        noBonus.y = 433
        noBonus.visible = false
        this.lotterySprite['tip5'] = noBonus
        this.lotteryContainer.addChild(noBonus)
        //按钮1
        let btn1 = PIXI.Sprite.from(lotteryId['button2.png'])
        btn1.interactive = true
        btn1.x = 266
        btn1.y = this.height / 2 + 300
        btn1.visible = false
        this.lotterySprite['btns'] = noBonus
        this.lotteryContainer.addChild(btn1)
        //中奖
        let isBonus = PIXI.Sprite.from(lotteryId['b_name1.png'])
        isBonus.anchor.set(1, 0)
        isBonus.x = 662
        isBonus.y = 287
        isBonus.visible = false
        title.addChild(isBonus)
        //提示
        let tip9 = PIXI.Sprite.from(lotteryId['tip9.png'])
        tip9.x = 485
        tip9.y = this.height / 2
        TweenMax.from(tip9, 1.5, {
          y: tip9.y - 40,
          x: tip9.x - 40,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })
        this.loadingSprite['lottery_tips9'] = tip9
        this.lotteryContainer.addChild(tip9)

        let tip7 = PIXI.Sprite.from(tipsId['tip2.png'])
        tip7.anchor.set(.5, 0)
        tip7.x = this.width / 2 - 15
        tip7.y = this.height / 2 + 150
        this.loadingSprite['lottery_tips7'] = tip7
        this.lotteryContainer.addChild(tip7)


        let close = PIXI.Sprite.from(tipsId['close.png'])
        close.anchor.set(0.5)
        close.x = this.width / 2
        close.y = this.height / 2 + 500
        close.interactive = true
        this.lotteryContainer.addChild(close)


        ligth.on('pointertap', () => {
          let data = new FormData()
          let time = Date.now()
          data.append('time', time)
          let t = md5('time=' + time + '&key=89e8e3c3178935065f99b6715d9ab333')
          data.append('t', t)
          axios.post('https://idea.elloworld.cn/jdapi/index.php/home/lottery', data).then((res) => {
            console.log(res)
            this.firstShare++;
            let p1 = res.data.data.prize_1_num_per_day
            let p2 = res.data.data.prize_2_num_per_day
            let p3 = res.data.data.prize_3_num_per_day
            let prize_probability = res.data.data.prize_probability
            let p = p1 + p2 + p3
            if (p <= 0) {
              prize_probability = 20
            }
            if (this.ifBonus === null) {
              this.playSound('click')
              let a = Math.random() * 10
              TweenMax.to(tip9, .5, {alpha: 0})
              TweenMax.to(tip7, .5, {alpha: 0})
              TweenMax.to(box, .5, {
                y: box.y - 500, onComplete: () => {
                  btn1.visible = true
                  btn1.alpha = 0
                  TweenMax.to(box, .5, {y: box.y + 500, delay: .5})
                  TweenMax.to(btn1, .5, {alpha: 1, delay: .5})
                }
              })
              TweenMax.to(ligth, .5, {
                alpha: 0, onComplete: () => {
                  if (a < prize_probability) {
                    this.playSound('nobonus')
                    ligth.texture = lotteryId['tip5.png']
                    ligth.x = 148
                    title.visible = false
                    isBonus.visible = false
                    btn1.texture = lotteryId['button2.png']
                    this.ifBonus = false
                  } else {
                    this.playSound('bonus')
                    title.visible = true
                    this.ifBonus = true
                    let b = 0
                    let random = Math.random()
                    if (random <= p1 / p) {
                      b = 1
                    }
                    if (random <= (p1 + p2) / p && random > p1 / p) {
                      b = 2
                    }
                    if (random > (p1 + p2) / p) {
                      b = 3
                    }
                    this.bonusType = b
                    title.texture = lotteryId['tip6.png']
                    isBonus.texture = lotteryId['b_name' + b + '.png']
                    isBonus.visible = true
                    ligth.texture = lotteryId['bonus' + b + '.png']
                    btn1.texture = lotteryId['button1.png']
                    switch (b) {
                      case 1:
                        ligth.x = 164
                        ligth.y = this.height / 2 - 50
                        break
                      case 2:
                        ligth.x = 194
                        ligth.y = this.height / 2 - 70
                        break;
                      case 3:
                        ligth.y = this.height / 2 - 20
                        ligth.x = 166
                        break;
                    }
                  }
                  this.loopAnimation(ligth, 1.5, 20)
                  TweenMax.to(ligth, .5, {alpha: 1, delay: .5})
                }
              })
            }

          })
        })

        let tipContainer = new PIXI.Container()
        let mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRect(0, 0, this.width, this.height);
        mask.endFill();
        mask.alpha = .85
        tipContainer.addChild(mask)
        this.lotteryContainer.addChild(tipContainer)

        let tips_title = PIXI.Sprite.from(lotteryId['tip_box.png'])
        tips_title.anchor.set(.5, 0)
        tips_title.x = this.width / 2
        tips_title.y = 0
        tipContainer.addChild(tips_title)

        let btn = PIXI.Sprite.from(lotteryId['getLottery.png'])
        btn.anchor.set(.5, 0)
        btn.x = this.width / 2
        btn.y = this.height / 2 + 150
        btn.interactive = true
        tipContainer.addChild(btn)
        btn.on('pointertap', () => {
          this.playSound('click')
          this.hidePageAnimate(tipContainer)
          this.showM = true
        })

        let out = PIXI.Sprite.from(lotteryId['out.png'])
        out.anchor.set(.5, 0)
        out.x = this.width / 2
        out.y = this.height / 2 + 300
        out.interactive = true

        out.on('pointertap', () => {
          this.playSound('click')
          this.hidePageAnimate(this.lotteryContainer)
        })
        tipContainer.addChild(out)

        tipContainer.visible = false
        tipContainer.interactive = true

        btn1.on('pointertap', () => {
          this.showM = true
          // console.log(this.ifBonus)
        })
        close.on('pointertap', () => {
          this.playSound('click')
          if (this.ifBonus) {
            this.showPageAnimate(tipContainer)
          } else {
            this.hidePageAnimate(this.lotteryContainer)
            TweenMax.to(this.loadingSprite.lottery_title, .5, {y: this.loadingSprite.lottery_title.y - 500})
          }
        })
      },
      createTips() {
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures
        let loadId = this.loaderImg.resources['./images/loading/loading.json'].textures

        let t_mask = PIXI.Sprite.from(tipsId['icon_mask.png'])
        this.app.stage.addChild(t_mask)

        let a = PIXI.Sprite.from(loadId['618.png'])
        a.x = 301
        a.y = -7
        this.loadingSprite['_618'] = a
        this.app.stage.addChild(a)


        let tipLight = PIXI.Sprite.from(tipsId['deng.png'])
        // tipLight.y = -500
        tipLight.x = 555
        tipLight.interactive = true
        this.loadingSprite['tipLight'] = tipLight
        this.app.stage.addChild(tipLight)

        let t_tip = PIXI.Sprite.from(tipsId['tip1.png'])
        t_tip.x = 424
        t_tip.y = 519
        t_tip.alpha = 1
        this.loadingSprite['t_tip'] = t_tip
        this.stageContainer.addChild(t_tip)

        tipLight.on('pointertap', () => {
          this.playSound('click')
          if (this.getLightNum === 6 && this.ifBonus === null) {
            this.showPageAnimate(this.lotteryContainer)
            TweenMax.to(this.loadingSprite.lottery_title, .5, {y: this.loadingSprite.lottery_title.y + 500})
          } else {
            this.showPageAnimate(this.tipsContainer)
            TweenMax.to(titleBox, .5, {
              y: (this.height / 2 - 730), ease: Power1.easeInOut, onComplete: () => {
                titleAni.play()
              }
            })
          }
        })

        let mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRect(0, 0, this.width, this.height);
        mask.endFill();
        mask.alpha = .85
        this.tipsContainer.addChild(mask)

        //云
        let yun1 = PIXI.Sprite.from(tipsId['t_yun1.png'])
        let yun2 = PIXI.Sprite.from(tipsId['t_yun2.png'])
        yun2.y = this.height - yun2.height
        yun2.x = 0
        yun1.y = this.height - yun1.height
        yun1.x = this.width - yun1.width
        this.loopAnimation(yun1, 2, 20)
        this.loopAnimation(yun2, 2, 20, 1)
        this.tipsContainer.addChild(yun2)
        this.tipsContainer.addChild(yun1)


        let titleBox = new PIXI.Sprite()
        let title = PIXI.Sprite.from(tipsId['title1.png'])
        titleBox.y = (this.height / 2 - 730) - title.height
        let titleAni = this.loopAnimation(title, 2, -20)
        titleAni.pause()
        titleBox.addChild(title)
        this.tipsContainer.addChild(titleBox)

        let light = PIXI.Sprite.from(tipsId['light2.png'])
        light.anchor.set(0, .5)
        light.x = 101
        light.y = this.height / 2 - 100
        this.tipsContainer.addChild(light)

        let grey = new PIXI.filters.ColorMatrixFilter()
        grey.greyscale(.4)
        for (let i = 0; i < 6; i++) {
          let a = PIXI.Sprite.from(tipsId['l' + (i + 1) + '.png'])
          a.anchor.set(.5)
          a.filters = [grey]
          switch (i) {
            case 0:
              a.x = 408
              a.y = 220 - light.height / 2
              break;
            case 1:
              a.x = 275
              a.y = -25 - light.height / 2
              break;
            case 2:
              a.x = 157
              a.y = 24 - light.height / 2
              break;
            case 3:
              a.x = 464
              a.y = 25 - light.height / 2
              break;
            case 4:
              a.x = 217
              a.y = 205 - light.height / 2
              break;
            case 5:
              a.x = 80
              a.y = 120 - light.height / 2
              break;
          }
          // a.visible = false
          this.loopAnimation(a, 1.5, -15, i / 5)
          light.addChild(a)
        }
        this.loadingSprite['t_light'] = light


        // console.log(light.children)
        let pro = PIXI.Sprite.from(tipsId['pro.png'])
        pro.x = 148
        pro.y = this.height / 2 + 56
        this.tipsContainer.addChild(pro)

        let txt = new PIXI.Text(this.getLightNum + '/6', {
          fontSize: 30,
          fill: '#b0adbe',
          fontWeight: 'bold',
        })
        txt.position.set(235, 47)
        this.loadingSprite['light_num'] = txt
        pro.addChild(txt)

        let tip1 = PIXI.Sprite.from(tipsId['tip2.png'])
        tip1.x = 26
        tip1.y = this.height / 2 + 106
        this.tipsContainer.addChild(tip1)

        let tip2 = PIXI.Sprite.from(tipsId['alert.png'])
        tip2.x = 317
        tip2.y = this.height / 2 + 406
        tip2.interactive = true
        this.tipsContainer.addChild(tip2)
        tip2.on('pointertap', () => {
          this.playSound('click')
          this.showPageAnimate(statementContainer)
        })

        let close = PIXI.Sprite.from(tipsId['close.png'])
        close.x = 335
        close.y = this.height / 2 + 500
        this.tipsContainer.addChild(close)
        close.interactive = true
        close.on('pointertap', () => {
          this.playSound('click')
          this.hidePageAnimate(this.tipsContainer)
          titleAni.pause()
          TweenMax.to(titleBox, .5, {y: (this.height / 2 - 730) - title.height, ease: Power1.easeInOut})
        })

        let statementContainer = new PIXI.Container()
        statementContainer.interactive = true
        statementContainer.visible = false
        this.tipsContainer.addChild(statementContainer)

        let mask2 = new PIXI.Graphics();
        mask2.beginFill(0x000000);
        mask2.drawRect(0, 0, this.width, this.height);
        mask2.endFill();
        mask2.alpha = .85
        statementContainer.addChild(mask2)

        let close1 = PIXI.Sprite.from(tipsId['close.png'])
        close1.x = 335
        close1.y = this.height / 2 + 500
        close1.interactive = true
        close1.on('pointertap', () => {
          this.playSound('click')
          this.hidePageAnimate(statementContainer)
        })

        let statement = PIXI.Sprite.from('./images/tips/statement.png')
        // statement.anchor.set(0.5, 0)
        statement.x = 170
        statementContainer.addChild(statement)
        statementContainer.addChild(close1)

        let box = new PIXI.Container()
        box.y = 350
        box.x = 15

        let rule = PIXI.Sprite.from('./images/tips/rule.png')
        box.addChild(rule)
        statement.addChild(box)

        let r_mask = new PIXI.Graphics()
        r_mask.beginFill(0xffffff, 1);
        r_mask.moveTo(0, 0)
        r_mask.lineTo(420, 0)
        r_mask.lineTo(420, 700)
        r_mask.lineTo(0, 700)
        box.addChild(r_mask)
        box.mask = r_mask
        box.interactive = true
        let objScroller = new Scroller(scrollerCallback, {
          scrollX: false
        })
        objScroller.setDimensions(350, 900, 410, 1500)
        box
          .on("pointerdown", onTouchStart)
          .on("pointermove", onTouchMove)
          .on("pointerup", onTouchEnd);

        function scrollerCallback(left, top, zoom) {
          rule.y = -top
        }

        let isTouching;

        function onTouchStart(e) {
          var i = e.data.originalEvent;
          isTouching = true;
          objScroller.doTouchStart(i.touches, i.timeStamp);
        }

        function onTouchMove(e) {
          if (isTouching) {
            var i = e.data.originalEvent;
            objScroller.doTouchMove(i.touches, i.timeStamp, i.scale);
          }
        }

        function onTouchEnd(e) {
          var i = e.data.originalEvent;
          objScroller.doTouchEnd(i.timeStamp);
          isTouching = false;
        }


      },
      createGetLight() {
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures
        let mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRect(0, 0, this.width, this.height);
        mask.endFill();
        mask.alpha = .85
        this.getLightContainer.addChild(mask)

        let titleBox = new PIXI.Sprite()
        let title = PIXI.Sprite.from(tipsId['tip4.png'])
        titleBox.x = 143
        titleBox.y = this.height / 2 - 740 - 800
        let titleAni = this.loopAnimation(title, 2, 20)
        titleAni.pause()
        this.loadingSprite['titleAni'] = titleAni
        this.loadingSprite['titleBox'] = titleBox
        titleBox.addChild(title)
        this.getLightContainer.addChild(titleBox)

        let littleLight = PIXI.Sprite.from(tipsId['l1.png'])
        littleLight.anchor.set(.5)
        littleLight.y = this.height / 2 - 206
        littleLight.x = this.width / 2
        this.loadingSprite['t_littleLight'] = littleLight
        // let ani = this.loopAnimation(littleLight, 1.5, 10)
        this.getLightContainer.addChild(littleLight)


        let tip1 = PIXI.Sprite.from(tipsId['gongxi.png'])
        tip1.x = 269
        tip1.y = this.height / 2 - 246
        this.getLightContainer.addChild(tip1)

        let tip2 = PIXI.Sprite.from(tipsId['tip3.png'])
        tip2.x = 105
        tip2.y = this.height / 2 + 80
        this.getLightContainer.addChild(tip2)

        let close = PIXI.Sprite.from(tipsId['close.png'])
        close.x = 325
        close.y = this.height / 2 + 320
        close.interactive = true
        this.getLightContainer.addChild(close)

        let effect1 = PIXI.Sprite.from(tipsId['guang.png'])
        effect1.x = 13.5
        this.getLightContainer.addChild(effect1)
        close.on('pointertap', () => {
          this.playSound('click')
          TweenMax.to(titleBox, .5, {y: this.height / 2 - 740 - 800})
          // ani.pause()
          this.hidePageAnimate(tip1)
          TweenMax.to(littleLight, .5, {
            x: 650, y: 140,
            onComplete: () => {
              if (this.shareContainer.visible) {
                this.posterImgShow = true
              }
              this.hidePageAnimate(this.getLightContainer)
              setTimeout(() => {
                littleLight.y = this.height / 2 - 206
                littleLight.x = this.width / 2
                littleLight.scale.set(1)
              }, 500)
            }
          })
          TweenMax.to(littleLight.scale, .5, {x: .2, y: .2})
        })
      },
      createShare() {
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures

        this.shareContainer = new PIXI.Container()
        this.shareContainer.zIndex = 18
        this.shareContainer.interactive = true
        this.shareContainer.visible = false
        let mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRect(0, 0, this.width, this.height);
        mask.endFill();
        mask.alpha = .85
        mask.interactive = true
        this.loadingSprite['share_mask'] = mask
        this.shareContainer.addChild(mask)


        let title = PIXI.Sprite.from(tipsId['save.png'])
        title.anchor.set(.5, 0)
        title.x = this.width / 2 + 10
        title.y = -30
        this.shareContainer.addChild(title)


        let share_img = PIXI.Sprite.from('./images/share_img/lenovo.png')
        // share_img.width = 574
        // share_img.height = 849
        share_img.anchor.set(.5)
        share_img.y = this.height / 2 - 80
        share_img.x = this.width / 2
        // share_img.interactive = true
        share_img.scale.set(.9)
        this.loadingSprite['share_img'] = share_img
        this.shareContainer.addChild(share_img)

        let box = new PIXI.Sprite()
        box.x = -207
        box.y = -325
        share_img.addChild(box)
        for (let i = 0; i < 4; i++) {
          let a = this.createlittleLight(i + 1, 0, 0)
          box.addChild(a)
          a.visible = false
        }
        this.loadingSprite['littleBox'] = box
        // console.log(box)

        let button = PIXI.Sprite.from(tipsId['button.png'])
        button.anchor.set(.5, 0)
        button.x = this.width / 2 - 20
        button.y = this.height / 2 + 350
        button.interactive = true
        button.scale.set(.8)
        this.shareContainer.addChild(button)
        button.on('pointertap', () => {
          this.playSound('click')
          MtaH5.clickStat(this.curProShop)
          window.location.href = this.curProduct
        })

        let close = PIXI.Sprite.from(tipsId['close.png'])
        close.anchor.set(.5)
        close.x = this.width / 2
        close.y = this.height / 2 + 550
        this.shareContainer.addChild(close)
        close.interactive = true
        close.on('pointertap', () => {
          this.playSound('click')
          // this.hidePageAnimate(this.shareContainer)
          // this.hidePageAnimate(mask)
          // this.hidePageAnimate(share_img)
          // this.loadingSprite.share_img.destroy()
          this.shareContainer.visible = false
          this.posterImgShow = false
        })

        this.app.stage.addChild(this.shareContainer)
      },
      createShopMask() {
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures

        let mask = new PIXI.Graphics();
        mask.beginFill(0x000000);
        mask.drawRect(0, 0, this.width, this.height);
        mask.endFill();
        mask.alpha = .85
        this.shopLogoContainer.addChild(mask)

        let title = new PIXI.Sprite()
        title.y = -1000
        this.loadingSprite['m_title'] = title
        this.shopLogoContainer.addChild(title)

        let btn = new PIXI.Sprite()
        btn.y = -1000
        this.loadingSprite['m_btn'] = btn
        this.shopLogoContainer.addChild(btn)
        btn.interactive = true
        btn.hitArea = new PIXI.Rectangle(255, 722, 240, 100)
        btn.on('pointertap', () => {
          this.playSound('click')
          MtaH5.clickStat(this.curProShop)
          window.location.href = this.curShop
        })


        let close = PIXI.Sprite.from(tipsId['close.png'])
        close.anchor.set(.5)
        close.x = this.width / 2
        close.y = this.height / 2 + 450
        close.interactive = true
        this.shopLogoContainer.addChild(close)
        close.on('pointertap', () => {
          this.playSound('click')
          this.shopLogoContainer.interactive = false
          this.hidePageAnimate(this.shopLogoContainer)
          TweenMax.to(this.loadingSprite.m_title, .5, {y: -1000})
          TweenMax.to(this.loadingSprite.m_btn, .5, {y: -1000})
        })
      },
      scrollerCallback(left, top, zoom) {
        this.stageContainer.y = -top;
        // console.log(-top - this.transY)

        // if (top > 0 && top < 10) {
        //   TweenMax.to(this.loadingSprite._618, .5, {y: -150, ease: Power1.easeInOut})
        // }

        this.loadingSprite._618.y = -top - this.transY
        if (this.loadingSprite._618.y > 0) {
          this.loadingSprite._618.y = 0
        }
        // if (top >= 800 && top <= 900) {
        //   // this.curTimeline = this.tl.lenovo3
        //   // this.tlplay = false
        //   this.mySprites.lenovo3.tar.y = this.mySprites.lenovo3.startY + (top - 800) / 2
        // } else {
        // this.tlplay = true
        //   this.mySprites.lenovo3.y = top < 800 ? this.mySprites.lenovo3.startY : this.mySprites.lenovo3.startY + 50
        // }
        // if (top >= 600 && top <= 700) {
        //   // this.curTimeline = this.tl.lenovo1
        //   // this.tlplay = false
        //   this.mySprites.lenovo1.tar.y = this.mySprites.lenovo1.startY + (top - 600) / 2
        // } else {
        //   // this.tlplay = true
        //   this.mySprites.lenovo1.y = top < 600 ? this.mySprites.lenovo1.startY : this.mySprites.lenovo1.startY + 50
        // }
        // if (top >= 1400 && top <= 1500) {
        //   this.mySprites.thinkpad1.tar.y = this.mySprites.thinkpad1.startY + (top - 1400) / 2
        // } else {
        //   this.mySprites.thinkpad1.y = top < 1400 ? this.mySprites.thinkpad1.startY : this.mySprites.thinkpad1.startY + 50
        // }
        // if (top >= 1300 && top <= 1400) {
        //   this.mySprites.thinkpad2.tar.y = this.mySprites.thinkpad2.startY + (top - 1300) / 2
        // } else {
        //   this.mySprites.thinkpad2.y = top < 1300 ? this.mySprites.thinkpad2.startY : this.mySprites.thinkpad2.startY + 50
        // }
        // if (top >= 1750 && top <= 1850) {
        //   this.mySprites.huashuo.tar.y = this.mySprites.huashuo.startY + (top - 1750) / 2
        // } else {
        //   this.mySprites.huashuo.y = top < 1750 ? this.mySprites.huashuo.startY : this.mySprites.huashuo.startY + 50
        // }
        // // if (top >= 2350 && top <= 2450) {
        // //   this.mySprites.bose1.tar.y = this.mySprites.bose1.startY + (top - 2350) / 2
        // // } else {
        // //   this.mySprites.bose1.y = top < 2350 ? this.mySprites.bose1.startY : this.mySprites.bose1.startY + 50
        // // }
        // if (top >= 2600 && top <= 2700) {
        //   this.mySprites.bose2.tar.y = this.mySprites.bose2.startY + (top - 2600) / 2
        // } else {
        //   this.mySprites.bose2.y = top < 2600 ? this.mySprites.bose2.startY : this.mySprites.bose2.startY + 50
        // }
        // if (top >= 3000 && top <= 3100) {
        //   this.mySprites.beat1.tar.y = this.mySprites.beat1.startY + (top - 3000) / 2
        // } else {
        //   this.mySprites.beat1.y = top < 3000 ? this.mySprites.beat1.startY : this.mySprites.beat1.startY + 50
        // }
        // // if (top >= 3100 && top <= 3200) {
        // //   this.mySprites.beat2.tar.y = this.mySprites.beat2.startY + (top - 3100) / 2
        // // } else {
        // //   this.mySprites.beat2.y = top < 3100 ? this.mySprites.beat2.startY : this.mySprites.beat2.startY + 50
        // // }
        // if (top >= 3900 && top <= 4000) {
        //   this.mySprites.lbl1.tar.y = this.mySprites.lbl1.startY + (top - 3900) / 2
        // } else {
        //   this.mySprites.lbl1.y = top < 3900 ? this.mySprites.lbl1.startY : this.mySprites.lbl1.startY + 50
        // }
        // if (top >= 5300 && top <= 5400) {
        //   this.mySprites.gopro1.tar.y = this.mySprites.gopro1.startY + (top - 5300) / 2
        // } else {
        //   this.mySprites.gopro1.y = top < 5300 ? this.mySprites.gopro1.startY : this.mySprites.gopro1.startY + 50
        // }
        // if (top >= 7700 && top <= 7800) {
        //   this.mySprites.wjgd1.tar.y = this.mySprites.wjgd1.startY + (top - 7700) / 2
        // } else {
        //   this.mySprites.wjgd1.y = top < 7700 ? this.mySprites.wjgd1.startY : this.mySprites.wjgd1.startY + 50
        // }
        // if (top >= 7800 && top <= 7900) {
        //   this.mySprites.fitbit1.tar.y = this.mySprites.fitbit1.startY + (top - 7800) / 2
        // } else {
        //   this.mySprites.fitbit1.y = top < 7800 ? this.mySprites.fitbit1.startY : this.mySprites.fitbit1.startY + 50
        // }
        // // if (top >= 8100 && top <= 8200) {
        // //   this.mySprites.seagate1.tar.y = this.mySprites.seagate1.startY + (top - 8100) / 2
        // // } else {
        // //   this.mySprites.seagate1.y = top < 8100 ? this.mySprites.seagate1.startY : this.mySprites.seagate1.startY + 50
        // // }
        // if (top >= 8150 && top <= 8250) {
        //   this.mySprites.deli1.tar.y = this.mySprites.deli1.startY + (top - 8150) / 2
        // } else {
        //   this.mySprites.deli1.y = top < 8150 ? this.mySprites.deli1.startY : this.mySprites.deli1.startY + 50
        // }
        // // if (top >= 8400 && top <= 8500) {
        // //   this.mySprites.three1.tar.y = this.mySprites.three1.startY + (top - 8400) / 2
        // // } else {
        // //   this.mySprites.three1.y = top < 8400 ? this.mySprites.three1.startY : this.mySprites.three1.startY + 50
        // // }
        // if (top >= 8700 && top <= 8800) {
        //   this.mySprites.mgwj1.tar.y = this.mySprites.mgwj1.startY + (top - 8700) / 2
        // } else {
        //   this.mySprites.mgwj1.y = top < 8700 ? this.mySprites.mgwj1.startY : this.mySprites.mgwj1.startY + 50
        // }

        if (top >= 9000) {
          if (this.isFirst) {
            this.loadingSprite.shanghaiAni.gotoAndPlay(0)
            this.canAni = true
            this.isFirst = false
          }
        }
      },
      stopTimeLine(e) {
        if (e) {
          this.curTimeline.resume()
        } else {
          this.curTimeline.pause()
        }
      },
      loopAnimation(tar, time, step, delay = 0, repeat = -1) {
        // let ani = new TimelineMax({repeat: repeat})
        // ani.to(tar, time, {y: tar.y + step, ease: Power1.easeInOut}).to(tar, time, {
        //   y: tar.y,
        //   ease: Power1.easeInOut
        // })
        let ani = TweenMax.to(tar, time, {
          y: tar.y + step,
          repeat: repeat,
          yoyo: true,
          delay: delay,
          ease: Power1.easeInOut
        })
        return ani
      },
      playVideo() {
        this.$refs.video.play()
        this.$refs.togglecity.play()
        this.$refs.bonus.play()
        this.$refs.nobonus.play()
        this.$refs.share.play()
        setTimeout(() => {
          this.$refs.video.pause()
          this.$refs.togglecity.pause()
          this.$refs.bonus.pause()
          this.$refs.nobonus.pause()
          this.$refs.share.pause()
        }, 10)
        var env = Env()
        if (env.isAndroid) {
          this.af.off('tap', this.playVideo)
          setTimeout(() => {
            this.showVideo = true
            this.$refs.video_box.style.backgroundColor = '#000'
            this.$refs.video.play()
            this.$refs.audio.pause()
          }, 800)
          setTimeout(() => {
            this.stageContainer.visible = true
            this.loadingContainer.destroy()
          }, 2000)
        } else {
          this.af.off('touchStart', this.playVideo)
          TweenMax.to(this.loadingSprite.l_title, .5, {y: -368})
          TweenMax.to(this.loadingSprite.layer, .5, {alpha: 0})
          this.loadingSprite.l_light.onLoop = () => {
            this.loadingSprite.l_light.gotoAndStop(36)
            setTimeout(() => {
              this.$refs.video_box.style.backgroundColor = '#000'
              this.$refs.video.play()
              this.$refs.audio.pause()
              this.showVideo = true
            }, 800)
            setTimeout(() => {
              this.stageContainer.visible = true
              this.loadingContainer.destroy()
            }, 2000)
          }
        }
        TweenMax.to(this.loadingSprite.lighter, 1, {
          alpha: 0, onComplete: () => {
            // this.loopAnimation(this.loadingSprite.l_title, 1.5, 0)
            // this.loadingSprite.l_title.y = 0
            this.$refs.video.addEventListener('ended', () => {
              // this.$refs.video_box.style.backgroundColor = '#000'
              TweenMax.to(this.$refs.video_box, .5, {
                opacity: 0, onComplete: () => {
                  // this.$refs.video.style.display = 'none'
                  this.videoShow = false
                  this.loadingSprite.feitan.play()
                  this.loadingSprite.bnh.play()
                  TweenMax.to(this.loadingSprite.s_title, 1.5, {
                    y: this.loadingSprite.s_title.y - 20,
                    repeat: -1,
                    yoyo: true,
                    ease: Power1.easeInOut
                  })
                }
              })
              this.$refs.audio.play()
              TweenMax.to(this.loadingSprite.t_tip, 1, {
                alpha: 1, onComplete: () => {
                  this.loopAnimation(this.loadingSprite.t_tip, 1.5, 5)
                }
              })
              TweenMax.to(this.loadingSprite.music, 1, {y: -100})
              TweenMax.to(this.loadingSprite.tipLight, 1, {y: 0})
            })
          }
        })
        TweenMax.to(this.loadingSprite.music, 1, {y: -360})
      },
      showPageAnimate(tar) {
        tar.visible = true
        tar.interactive = true
        TweenMax.to(tar, 0.5, {
          alpha: 1
        })

      },
      hidePageAnimate(tar) {
        tar.interactive = false
        TweenMax.to(tar, .5, {
          alpha: 0, onComplete: () => {
            tar.visible = false
          }
        })
      },
      initCitySnap() {
        let _this = this
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures

        let yunContainer = new PIXI.Container()
        yunContainer.y = 10200
        let yunAni1 = this.createYunAni('yun_t', 20)
        yunContainer.addChild(yunAni1)
        yunAni1.scale.set(.5)
        yunAni1.alpha = .5
        yunAni1.play()
        this.stageContainer.addChild(yunContainer)


        let yunAni2 = this.createYunAni('yun_t', 20)
        yunContainer.addChild(yunAni2)
        yunAni2.scale.set(.5)
        yunAni2.alpha = .5
        yunAni2.y = 200
        yunAni2.x = 600
        yunAni2.play()
        yunContainer.addChild(yunAni2)


        let citySnapContainer = new PIXI.Container()
        // citySnapContainer.interactive = true
        citySnapContainer.y = 11439 - 1500
        citySnapContainer.zIndex = 10
        this.stageContainer.addChild(citySnapContainer)
        let shanghai = PIXI.Sprite.from('./images/city/shanghai_an.png')
        let shanghai_l = PIXI.Sprite.from('./images/city/shanghai_liang.png')
        shanghai.addChild(shanghai_l)

        let shanghai1 = PIXI.Sprite.from('./images/city/shanghai_an.png')
        let shanghai1_l = PIXI.Sprite.from('./images/city/shanghai_liang.png')
        shanghai1.addChild(shanghai1_l)

        let hangzhou = PIXI.Sprite.from('./images/city/hangzhou_an.png')
        let hangzhou_l = PIXI.Sprite.from('./images/city/hangzhou_liang.png')
        hangzhou.addChild(hangzhou_l)
        let guangzhou = PIXI.Sprite.from('./images/city/guangzhou_an.png')
        let guangzhou_l = PIXI.Sprite.from('./images/city/guangzhou_liang.png')
        guangzhou.addChild(guangzhou_l)
        let chengdu = PIXI.Sprite.from('./images/city/chengdu_an.png')
        let chengdu_l = PIXI.Sprite.from('./images/city/chengdu_liang.png')
        chengdu.addChild(chengdu_l)
        let chengdu1 = PIXI.Sprite.from('./images/city/chengdu_an.png')
        let chengdu1_l = PIXI.Sprite.from('./images/city/chengdu_liang.png')
        chengdu1.addChild(chengdu1_l)

        TweenMax.from(chengdu_l, 1, {
          alpha: .7,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })
        TweenMax.from(shanghai_l, 1, {
          alpha: .7,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })
        TweenMax.from(shanghai1_l, 1, {
          alpha: .7,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })
        TweenMax.from(hangzhou_l, 1, {
          alpha: .7,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })
        TweenMax.from(guangzhou_l, 1, {
          alpha: .7,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })
        TweenMax.from(chengdu1_l, 1, {
          alpha: .7,
          repeat: -1,
          yoyo: true,
          ease: Power1.easeInOut
        })

        chengdu1.x = 0
        shanghai.x = 1066
        hangzhou.x = 1066 * 2
        guangzhou.x = 1066 * 3
        chengdu.x = 1066 * 4
        shanghai1.x = 1066 * 5
        citySnapContainer.addChild(shanghai)
        citySnapContainer.addChild(hangzhou)
        citySnapContainer.addChild(guangzhou)
        citySnapContainer.addChild(chengdu)
        citySnapContainer.addChild(shanghai1)
        citySnapContainer.addChild(chengdu1)

        // console.log(citySnapContainer.width)
        citySnapContainer.hitArea = new PIXI.Rectangle(0, 500, 1066 * 6, 800)

        let shanghaiTexture = []
        let hangzhouTexture = []
        let guangzhouTexture = []
        let chengduTexture = []

        let p2 = false, p3 = false, p4 = false
        for (let i = 0; i < 29; i++) {
          let a = PIXI.Texture.from('shanghai' + (29 - i) + '.png');
          shanghaiTexture.push(a)
        }
        for (let j = 0; j < 31; j++) {
          let a = PIXI.Texture.from('hangzhou' + (31 - j) + '.png');
          hangzhouTexture.push(a)
        }
        for (let k = 0; k < 30; k++) {
          let a = PIXI.Texture.from('guangzhou' + (30 - k) + '.png');
          guangzhouTexture.push(a)
        }
        for (let l = 0; l < 28; l++) {
          let a = PIXI.Texture.from('chengdu' + (28 - l) + '.png');
          chengduTexture.push(a)
        }


        let shanghaiAni = new PIXI.AnimatedSprite(shanghaiTexture);
        shanghaiAni.anchor.set(0.5)
        shanghaiAni.x = 190
        shanghaiAni.y = 995
        shanghaiAni.animationSpeed = .5
        shanghaiAni.loop = false
        shanghai.addChild(shanghaiAni)
        shanghaiAni.interactive = true
        shanghaiAni.on('pointertap', () => {
          this.$refs.audio.pause()
          this.$refs.city_video.src = 'https://leou-video.s3.cn-east-2.jdcloud-oss.com/desirecity/shanghai.mp4'
          this.cityVideoShow = true
          this.$refs.city_video.play()
          MtaH5.clickStat('shanghai_video')
          this.$refs.city_video.addEventListener('ended', () => {
            this.cityVideoShow = false
            this.$refs.audio.play()
          })
        })

        this.loadingSprite['shanghaiAni'] = shanghaiAni
        shanghaiAni.onComplete = function () {
          TweenMax.to(play_tip1, 0.5, {alpha: 1})
        }

        // let shanghaiAni1 = PIXI.Sprite.from(this.loader.resources['./images/city/city_ani.json'].textures['shanghai1.png'])
        // shanghaiAni1.anchor.set(0.5)
        // shanghaiAni1.x = 190
        // shanghaiAni1.y = this.height / 2 + 350
        // shanghaiAni1.animationSpeed = .5
        // shanghai1.addChild(shanghaiAni1)
        // shanghaiAni1.onComplete = function () {
        //   TweenMax.to(play_tip2, 0.5, {alpha: 1})
        // }

        let hangzhouAni = new PIXI.AnimatedSprite(hangzhouTexture);
        hangzhouAni.anchor.set(0.5)
        hangzhouAni.x = 176
        hangzhouAni.y = 995
        hangzhouAni.animationSpeed = .5
        hangzhouAni.loop = false
        hangzhou.addChild(hangzhouAni)
        hangzhouAni.interactive = true
        hangzhouAni.on('pointertap', () => {
          this.$refs.audio.pause()
          this.$refs.city_video.src = 'https://leou-video.s3.cn-east-2.jdcloud-oss.com/desirecity/hangzhou.mp4'
          this.cityVideoShow = true
          this.$refs.city_video.play()
          MtaH5.clickStat('hangzhou_video')
          this.$refs.city_video.addEventListener('ended', () => {
            this.cityVideoShow = false
            this.$refs.audio.play()
          })
        })
        hangzhouAni.onComplete = function () {
          TweenMax.to(play_tip3, 0.5, {alpha: 1})
        }

        let guangzhouAni = new PIXI.AnimatedSprite(guangzhouTexture);
        guangzhouAni.anchor.set(0.5)
        guangzhouAni.x = 540
        guangzhouAni.y = 560
        guangzhouAni.animationSpeed = .5
        guangzhouAni.loop = false
        guangzhou.addChild(guangzhouAni)
        guangzhouAni.interactive = true
        guangzhouAni.on('pointertap', () => {
          this.$refs.audio.pause()
          this.$refs.city_video.src = 'https://leou-video.s3.cn-east-2.jdcloud-oss.com/desirecity/guangzhou.mp4'
          this.cityVideoShow = true
          this.$refs.city_video.play()
          MtaH5.clickStat('guangzhou_video')
          this.$refs.city_video.addEventListener('ended', () => {
            this.cityVideoShow = false
            this.$refs.audio.play()

          })
        })
        guangzhouAni.onComplete = function () {
          TweenMax.to(play_tip4, 0.5, {alpha: 1})
        }

        let chengduAni = new PIXI.AnimatedSprite(chengduTexture);
        chengduAni.anchor.set(0.5)
        chengduAni.x = 500
        chengduAni.y = 550
        chengduAni.animationSpeed = .5
        chengduAni.loop = false
        chengdu.addChild(chengduAni)
        chengduAni.interactive = true
        chengduAni.on('pointertap', () => {
          this.$refs.audio.pause()
          this.$refs.city_video.src = 'https://leou-video.s3.cn-east-2.jdcloud-oss.com/desirecity/chengdu.mp4'
          this.cityVideoShow = true
          this.$refs.city_video.play()
          MtaH5.clickStat('chengdu_video')
          this.$refs.city_video.addEventListener('ended', () => {
            this.cityVideoShow = false
            this.$refs.audio.play()
          })
        })
        chengduAni.onComplete = function () {
          TweenMax.to(play_tip5, 0.5, {alpha: 1})
        }

        // let chengduAni1 = PIXI.Sprite.from(this.loader.resources['./images/city/city_ani.json'].textures['chengdu1.png'])
        // chengduAni1.anchor.set(0.5)
        // chengduAni1.x = 500
        // chengduAni1.y = 550
        // chengduAni1.animationSpeed = .5
        // chengdu1.addChild(chengduAni1)
        // chengdu1.visible = false
        // chengduAni1.onComplete = function () {
        //   TweenMax.to(play_tip6, 0.5, {alpha: 1})
        // }


        let play_tip1 = PIXI.Sprite.from(tipsId['play_tips.png'])
        play_tip1.x = 120
        play_tip1.y = this.height / 2 + 300
        shanghai.addChild(play_tip1)
        play_tip1.alpha = 0
        this.loopAnimation(play_tip1, 2, -20)

        let play_tip2 = PIXI.Sprite.from(tipsId['play_tips.png'])
        play_tip2.x = 120
        play_tip2.y = this.height / 2 + 300
        shanghai1.addChild(play_tip2)
        play_tip2.alpha = 0

        this.loopAnimation(play_tip2, 2, -20)

        let play_tip3 = PIXI.Sprite.from(tipsId['play_tips.png'])
        play_tip3.x = 80
        play_tip3.y = 940
        hangzhou.addChild(play_tip3)
        this.loopAnimation(play_tip3, 2, -20)
        play_tip3.alpha = 0

        let play_tip4 = PIXI.Sprite.from(tipsId['play_tips.png'])
        play_tip4.x = 400
        play_tip4.y = this.height / 2 - 130
        guangzhou.addChild(play_tip4)
        this.loopAnimation(play_tip4, 2, -20)
        play_tip4.alpha = 0

        let play_tip5 = PIXI.Sprite.from(tipsId['play_tips.png'])
        play_tip5.x = 400
        play_tip5.y = this.height / 2 - 150
        chengdu.addChild(play_tip5)
        this.loopAnimation(play_tip5, 2, -20)
        play_tip5.alpha = 0

        let play_tip6 = PIXI.Sprite.from(tipsId['play_tips.png'])
        play_tip6.x = 400
        play_tip6.y = this.height / 2 - 150
        chengdu1.addChild(play_tip6)
        this.loopAnimation(play_tip6, 2, -20)
        play_tip6.alpha = 0

        let l
        let a = Math.floor(Math.random() * 2)
        if (a === 0) {
          l = this.createlittleLight(5, 200, 650)
        } else {
          l = this.createlittleLight(5, 400, 800)
        }
        citySnapContainer.children[1 + a].addChild(l)

        let l_arrow = this.createFrameAni('arrow', 20, .3)
        let r_arrow = this.createFrameAni('arrow', 20, .3)
        l_arrow.interactive = true
        r_arrow.interactive = true
        l_arrow.y = 11439 - 250
        l_arrow.x = 50
        r_arrow.y = 11439 - 250
        r_arrow.x = 700
        r_arrow.scale.x = -1
        l_arrow.zIndex = 10
        r_arrow.zIndex = 10
        l_arrow.play()
        r_arrow.play()
        this.stageContainer.addChild(l_arrow)
        this.stageContainer.addChild(r_arrow)
        // this.loopAnimation(r_arrow, 1.5, -20)
        // this.loopAnimation(l_arrow, 1.5, -20)
        l_arrow.on('pointertap', (e) => {
          e.stopPropagation()
          this.playSound('togglecity')
          cur = citySnapContainer.x
          let a = citySnapContainer.x
          objScroller.scrollTo(-a - 1066, 0, true)
        })
        r_arrow.on('pointertap', (e) => {
          e.stopPropagation()
          this.playSound('togglecity')
          cur = citySnapContainer.x
          let a = citySnapContainer.x
          objScroller.scrollTo(-a + 1066, 0, true)
        })
        let objScroller = new Scroller(scrollCallback, {
          scrollY: false,
          bouncing: false,
          paging: true,
          animationDuration: 1000
        });

        var scrollX = 1066 * 6; //视具体视觉效果而定
        objScroller.setDimensions(
          1066,
          this.app.screen.height,
          scrollX,
          this.app.screen.height
        );
        citySnapContainer
          .on("pointerdown", onTouchStart)
          .on("pointermove", onTouchMove)
          .on("pointerup", onTouchEnd);

        let isTouching;
        objScroller.scrollTo(1066, 0, false)
        let cur

        function scrollCallback(left, top, zoom) {
          // console.log(left)
          citySnapContainer.x = -left
          if (left + cur > 0) {
            yunContainer.x -= 1
          } else {
            yunContainer.x += 1
          }
          if (left === 1066 * 5) {
            objScroller.scrollTo(1066, 0, false)
          }
          if (left === 0) {
            objScroller.scrollTo(1066 * 4, 0, false)
          }
          if (left > 0 && left < 1066 * 2) {
            shanghai.y = -Math.abs(1066 - left) / 10
            shanghai1.y = -Math.abs(1066 - left) / 10
          }
          if (left > 1066 * 4 && left < 1066 * 5) {
            shanghai.y = -(1066 * 5 - left) / 10
            shanghai1.y = -(1066 * 5 - left) / 10
          }
          if (left > 1066 && left < 1066 * 3) {
            hangzhou.y = -Math.abs(1066 * 2 - left) / 10
          }
          if (left > 1066 * 2 && left < 1066 * 4) {
            guangzhou.y = -Math.abs(1066 * 3 - left) / 10
          }
          if (left > 1066 * 3 && left < 1066 * 5) {
            chengdu.y = -Math.abs(1066 * 4 - left) / 10
            chengdu1.y = -Math.abs(1066 * 4 - left) / 10
          }
          if (left > 0 && left < 1066) {
            chengdu.y = -left / 10
            chengdu1.y = -left / 10
          }
          if (_this.canAni) {
            switch (left) {
              case 1066:
                play_tip1.alpha = 0
                play_tip2.alpha = 0
                play_tip3.alpha = 0
                play_tip4.alpha = 0
                play_tip5.alpha = 0
                play_tip6.alpha = 0
                hangzhouAni.gotoAndStop(0)
                shanghaiAni.gotoAndPlay(0)
                chengduAni.gotoAndStop(0)
                guangzhouAni.gotoAndStop(0)
                break;
              case 1066 * 2:
                play_tip1.alpha = 0
                play_tip2.alpha = 0
                play_tip3.alpha = 0
                play_tip4.alpha = 0
                play_tip5.alpha = 0
                play_tip6.alpha = 0
                hangzhouAni.gotoAndPlay(0)
                shanghaiAni.gotoAndStop(0)
                chengduAni.gotoAndStop(0)
                guangzhouAni.gotoAndStop(0)
                break;
              case 1066 * 3:
                play_tip1.alpha = 0
                play_tip2.alpha = 0
                play_tip3.alpha = 0
                play_tip4.alpha = 0
                play_tip5.alpha = 0
                play_tip6.alpha = 0
                guangzhouAni.gotoAndPlay(0)
                shanghaiAni.gotoAndStop(0)
                chengduAni.gotoAndStop(0)
                hangzhouAni.gotoAndStop(0)
                break;
              case 1066 * 4 :
                play_tip1.alpha = 0
                play_tip2.alpha = 0
                play_tip3.alpha = 0
                play_tip4.alpha = 0
                play_tip5.alpha = 0
                play_tip6.alpha = 0
                chengduAni.gotoAndPlay(0)
                guangzhouAni.gotoAndStop(0)
                shanghaiAni.gotoAndStop(0)
                hangzhouAni.gotoAndStop(0)
                break;
              // case 1066 * 5 :
              //   if (_this.curPage !== 1) {
              //     _this.curPage = 1
              //     play_tip1.alpha = 0
              //     play_tip2.alpha = 0
              //     play_tip3.alpha = 0
              //     play_tip4.alpha = 0
              //     play_tip5.alpha = 0
              //     play_tip6.alpha = 0
              //     chengduAni.gotoAndStop(0)
              //     guangzhouAni.gotoAndStop(0)
              //     shanghaiAni.gotoAndPlay(0)
              //     hangzhouAni.gotoAndStop(0)
              //   }
              //   break;
              case 0 :
                play_tip1.alpha = 0
                play_tip2.alpha = 0
                play_tip3.alpha = 0
                play_tip4.alpha = 0
                play_tip5.alpha = 0
                play_tip6.alpha = 0
                chengduAni.gotoAndPlay(0)
                guangzhouAni.gotoAndStop(0)
                shanghaiAni.gotoAndStop(0)
                hangzhouAni.gotoAndStop(0)
                break;
            }
            // if (p4) {
            //   chengdu1.visible = true
            // }
          }
        }

        function onTouchStart(e) {
          e.stopPropagation()
          cur = citySnapContainer.x
          var i = e.data.originalEvent;
          isTouching = true;
          objScroller.doTouchStart(i.touches, i.timeStamp);
        }

        function onTouchMove(e) {
          // e.stopPropagation()
          if (isTouching) {
            var i = e.data.originalEvent;
            objScroller.doTouchMove(i.touches, i.timeStamp, i.scale);
          }
        }

        function onTouchEnd(e) {
          var i = e.data.originalEvent;
          objScroller.doTouchEnd(i.timeStamp);
          isTouching = false;
        }
      },
      createlittleLight(index, x, y) {
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures
        let littleLight = PIXI.Sprite.from(tipsId['l' + (index + 1) + '.png'])
        littleLight.anchor.set(.5)
        littleLight.x = x
        littleLight.y = y
        littleLight.scale.set(.8)
        littleLight.interactive = true
        let ani = this.loopAnimation(littleLight, 2, -10)
        littleLight.on('pointertap', (e) => {
          this.playSound('light')
          littleLight.interactive = false
          console.log(this.loadingSprite.littleBox)
          this.loadingSprite.t_tip.visible = false
          ani.pause()
          this.loadingSprite.t_littleLight.texture = tipsId['l' + (index + 1) + '.png']
          this.loadingSprite.t_light.children[index].filters = []
          this.lightStage['l' + (index + 1)] = true
          this.getLightNum++;
          if (this.getLightNum !== 6) {
            this.showPageAnimate(this.getLightContainer)
            this.posterImgShow = false
            this.playSound('getlight')
          }
          TweenMax.to(littleLight, .5, {
            alpha: 0, onComplete: () => {
              // littleLight.destroy()
            }
          })
          TweenMax.to(this.loadingSprite.titleBox, .5, {y: this.height / 2 - 740})
        })
        return littleLight
      },
      createTitleAni(name, frame) {
        let t = []
        for (let i = 0; i < frame; i++) {
          let a = PIXI.Texture.from(name + (i + 1) + '.png')
          t.push(a)
        }
        let ani = new PIXI.AnimatedSprite(t)
        ani.animationSpeed = .1
        return ani

      },
      createYunAni(name, frame) {
        let t = []
        for (let i = 0; i < frame; i++) {
          let a = PIXI.Texture.from(name + (i + 1) + '.png')
          t.push(a)
        }
        let ani = new PIXI.AnimatedSprite(t)
        ani.animationSpeed = .2
        return ani

      },
      createFrameAni(name, frame, speed) {
        let t = []
        for (let i = 0; i < frame; i++) {
          let a = PIXI.Texture.from(name + (i + 1) + '.png')
          t.push(a)
        }
        let ani = new PIXI.AnimatedSprite(t)
        ani.animationSpeed = speed
        return ani
      },
      createProTip(isHand) {
        let tipsId = this.loader.resources['./images/tips/tips.json'].textures
        let a = PIXI.Sprite.from(tipsId['pro_tip.png'])
        let b = PIXI.Sprite.from('hand_tip.png')
        let c = PIXI.Sprite.from('hand_cir.png')
        let box = new PIXI.Sprite()
        a.addChild(box)
        box.addChild(c)
        box.addChild(b)
        box.position.set(72, 0)
        c.position.set(10, 80)
        c.anchor.set(.5)
        TweenMax.to(c, 1, {alpha: .5, repeat: -1, yoyo: true})
        TweenMax.to(c.scale, 1, {x: 0.8, y: .8, repeat: -1, yoyo: true})
        if (isHand) {
          box.interactive = true
          box.on('pointertap', () => {
            TweenMax.to(a, .3, {
              alpha: 0, onComplete: () => {
                box.destroy()
              }
            })

          })
          return box
        } else {
          box.interactive = true
          box.on('pointertap', () => {
            TweenMax.to(a, .3, {
              alpha: 0, onComplete: () => {
                box.destroy()
              }
            })
          })
          return a
        }
      },
      checkPhone(e) {
        window.scroll(0, 0);
        var phone = e.target.value
        if (!(/^1[34578]\d{9}$/.test(phone))) {
          this.phoneWrong = true
        } else {
          this.phoneWrong = false
          this.message.phone = phone
        }
      },
      checkName(e) {
        var a = e.target.value
        var b = a.replace(/(^\s*)|(\s*$)/g, "")
        if (b) {
          this.nameWrong = false
          this.message.name = b;
        } else {
          this.nameWrong = true
        }
        window.scroll(0, 0);
      },
      checkAddress(e) {
        var a = e.target.value
        var b = a.replace(/(^\s*)|(\s*$)/g, "")
        if (b) {
          this.addressWrong = false
          this.message.address = b
        } else {
          this.addressWrong = true
        }
        window.scroll(0, 0);
      },
      submitMes() {
        let data = new FormData()
        let time = Date.now()
        data.append('time', time)
        let t = md5('phone=' + this.message.phone + '&time=' + time + '&key=89e8e3c3178935065f99b6715d9ab333')
        data.append('t', t)
        data.append('name', this.message.name)
        data.append('phone', this.message.phone)
        data.append('address', this.message.address)
        data.append('prizeType', this.bonusType)

        axios.post(this.mainUrl, data).then((res) => {
          console.log(res)
          this.resultShow = true
          if (res.data.data.isFirst === 1) {
            this.ifSuccess = true
          } else {
            this.ifSuccess = false
          }
          // this.$refs.close.addEventListener('click',()=>{
          //   this.resultShow = false
          //   if (ifSuccess) {
          //     this.showM = false
          //     this.lotteryContainer.visible = false
          //     TweenMax.to(this.loadingSprite.tipLight, 1, {y: -500})
          //   }
          // })
        })
      },
      closeResult() {
        this.resultShow = false
        if (this.ifSuccess) {
          this.showM = false
          this.lotteryContainer.visible = false
          TweenMax.to(this.loadingSprite.tipLight, 1, {y: -500})
        }
      },
      playSound(name) {
        this.$refs[name].play()
      },
      // createshareImg(name) {
      //   let share_img = PIXI.Sprite.from('./images/share_img/' + name + '.png')
      //   // share_img.width = 574
      //   // share_img.height = 849
      //   share_img.anchor.set(.5)
      //   share_img.y = this.height / 2 - 80
      //   share_img.x = this.width / 2
      //   // share_img.interactive = true
      //   share_img.scale.set(.9)
      //   this.loadingSprite['share_img'] = share_img
      //   this.shareContainer.addChild(share_img)
      // },
      pauseVideo() {
        this.$refs.city_video.pause()
        this.cityVideoShow = false
        this.$refs.audio.play()
      }
    },
    watch: {
      tlplay(e) {
        this.stopTimeLine(e)
      },
      getLightNum(e) {
        // console.log(e)
        this.loadingSprite.light_num.text = e + '/6'
        if (e === 6) {
          this.showPageAnimate(this.lotteryContainer)
          TweenMax.to(this.loadingSprite.lottery_title, .5, {y: this.loadingSprite.lottery_title.y + 500})
        }
      },
      share_success() {
        if (this.firstShare === 2) {
          if (this.ifBonus !== null) {
            this.lotteryContainer.destroy()
            this.createLotteryPage()
            this.showPageAnimate(this.lotteryContainer)
            TweenMax.to(this.loadingSprite.lottery_title, .5, {y: this.loadingSprite.lottery_title.y + 500})
            this.ifBonus = null
          }
        }
        // this.loadingSprite.lottery_light.texture=
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  #home {
    width: 100%;
    height: 100%;
    position: relative;

    .inputArea {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;


      .message-bg {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        margin-top: -100px;
        transform: translate(-50%, -50%);
      }

      .tips2, .tips3 {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 2;
        transform: translate(-50%, -50%);
      }

      .tips2 {
        margin-top: 200px;

      }

      .tips3 {
        margin-top: -410px;

      }

      .top-tips {
        position: absolute;
        top: 0;
        left: 50%;
        z-index: 1;
        transform: translateX(-50%);
      }


      .btn {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        margin-top: 350px;
        transform: translate(-50%, -50%);
      }

      .close {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1;
        margin-top: 500px;
        transform: translate(-50%, -50%);
      }

      input {
        outline: none;
        border: none;
        font-size: 24px;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0);
        padding-left: 14px;
        color: #2a39b7;
      }

      .name, .phone {
        position: absolute;
        top: 158px;
        left: 192px;
        width: 245px;
        height: 44px;
      }

      .phone {
        top: 260px;
      }

      .address {
        outline: none;
        border: none;
        color: #2a39b7;
        font-size: 24px;
        padding-left: 14px;
        padding-top: 4px;
        box-sizing: border-box;
        background-color: rgba(0, 0, 0, 0);
        position: absolute;
        top: 369px;
        left: 192px;
        width: 245px;
        height: 90px;

      }

      &::after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .7);
      }

      .wrong1 {
        position: absolute;
        top: 217px;
        left: 191px;
        color: #fff;
        display: flex;
        align-items: center;
        font-size: 16px;

        img {
          margin-right: 5px;
        }
      }

      .wrong2 {
        position: absolute;
        top: 323px;
        left: 191px;
        color: #fff;
        display: flex;
        align-items: center;
        font-size: 16px;

        img {
          margin-right: 5px;
        }

        /*letter-spacing: ;*/
      }

      .wrong3 {
        position: absolute;
        top: 475px;
        left: 191px;
        color: #fff;
        display: flex;
        align-items: center;
        font-size: 16px;

        img {
          margin-right: 5px;
        }
      }

      .share {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;

        .s-mask {
          position: absolute;
          right: 0;
          top: 0;
        }

        .animte {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          animation: ani 2s ease-in-out infinite;

          .s-light {
            position: absolute;
            top: 0;
            right: 0;
          }

          .s-tips {
            position: absolute;
            top: 300px;
            right: 75px;
          }

          .s-star {
            position: absolute;
            top: 0;
            right: 0;
            animation: show 1.5s ease-in-out infinite;
          }
        }
      }
    }

    .result {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, .85);
      z-index: 10;

      .success, .failure {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: -200px;
      }

      .close {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin-top: 400px;

      }
    }

    .progress {
      width: 290px;
      height: 10px;
      position: absolute;
      left: 50%;
      top: 930px;
      transform: translateX(-50%);
      /*margin-top: 270px;*/
      background-color: rgba(255, 255, 255, .3);
      /*transform: translate(-50%, 50%);*/
      border-radius: 5px;
      overflow: hidden;

      .loaded {
        width: 10%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: #fff;

        &::after {
          content: '';
          width: 50px;
          height: 10px;
          background: linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
          position: absolute;
          top: 0;
          right: -50px;
        }


      }
    }

    .after {
      position: absolute;
      left: 246px;
      top: 899px;
      animation: show 1.5s ease-in-out infinite;
      /*transform: translateX(-50%);*/
    }

    .poster {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      background-color: rgba(0, 0, 0, .85);
      pointer-events: none;

      /*.title {*/
      /*position: absolute;*/
      /*top: 0;*/
      /*left: 50%;*/
      /*transform: translateX(-50%);*/
      /*}*/

      .poster-img {
        position: absolute;
        top: 50%;
        left: 50%;
        /*margin-top: -100px;*/
        transform: translate(-50%, -50%) scale(.9);
        pointer-events: auto;
        height: 723px;

        img {
          pointer-events: auto;
          height: 690px;
        }
      }

      /*.close {*/
      /*position: absolute;*/
      /*top: 50%;*/
      /*left: 50%;*/
      /*margin-top: 400px;*/
      /*transform: translate(-50%, -50%);*/

      /*}*/
    }

    .video-box {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      /*background-color: #000;*/
    }

    .video {
      position: absolute;
      left: 186px;
      top: 656px;
      z-index: 100;
      opacity: 0;
      width: 384px;
      height: 259px;
    }

    .videoplaying {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      width: 100%;
    }

    .video-wrapper {
      width: 100%;
      height: 100%;
      background-color: #000;
      position: absolute;
      top: 0;
      z-index: 10;
      left: 0;
      /*display: flex;*/
      /*align-items: center;*/
      /*justify-content: space-between;*/

      .city-video {
        width: 100vh;
        /*height: 100%;*/
        /*height: 100vh;*/
        position: absolute;
        transform-origin: 0 0;
        top: 0;
        /*left: -375px;*/
        transform: rotate(90deg) translateY(-50%);
      }

      .close {
        position: absolute;
        right: 10px;
        top: 20px;
      }
    }


    canvas {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .fadeInOut-enter-active, .fadeInOut-leave-active {
    transition: opacity .5s;
  }

  .fadeInOut-enter, .fadeInOut-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  @keyframes ani {
    0% {
      transform: translateY(20px);
    }
    50% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(20px);
    }
  }

  @keyframes show {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
